import { render, staticRenderFns } from "./review-status-selector.vue?vue&type=template&id=4efdcfcf&scoped=true&lang=pug"
import script from "./review-status-selector.vue?vue&type=script&lang=ts"
export * from "./review-status-selector.vue?vue&type=script&lang=ts"
import style0 from "./review-status-selector.vue?vue&type=style&index=0&id=4efdcfcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efdcfcf",
  null
  
)

export default component.exports